import i18n from 'i18next';

import { LocationGroupType, LocationSuggestionGroupFragment } from '@websky/graphql';

import { Group, Option } from '../Autocomplete/types';

import { Location } from './types';
import { LocationType } from '../types';

export const filterGroupsForDirectionsDialog = (groups: Group<Location>[]): Group<Location>[] => {
	return !!groups?.length ? groups.filter(item => 'type' in item && item.type === LocationGroupType.Country) : [];
};

export const parseLocationGroups = (
	groups: LocationSuggestionGroupFragment[],
	query: string,
	locationType: LocationType
): Group<Location>[] => {
	// In case of no-results.
	if (groups && !groups.length) {
		return !!query.trim()
			? [
					{
						label: `${i18n.t('LocationAutocomplete:Sorry, we do not fly')} ${
							locationType === LocationType.Departure
								? i18n.t('LocationAutocomplete:from')
								: i18n.t('LocationAutocomplete:to')
						}`,
						options: [
							{
								label: query,
								value: null
							}
						]
					}
			  ]
			: [];
	}

	return groups.map<Group<Location>>(group => {
		let label: string;

		const options = group.cities.map<Option<Location>>(city => ({
			label: city.name,
			value: city
		}));

		switch (group.type) {
			case LocationGroupType.Country:
				label = group.country.name;
				break;

			case LocationGroupType.Nearest:
				label = i18n.t('LocationAutocomplete:Nearby airports');
				break;

			case LocationGroupType.Popular:
				label = i18n.t('LocationAutocomplete:Popular airports');
				break;

			case LocationGroupType.AdditionalCities:
				label = i18n.t('LocationAutocomplete:Recent searches');
				break;
		}

		return {
			label,
			options,
			type: group.type
		};
	});
};
